/*
 * Mercado según dónde está el visitante, sin apps ni servicios externos: se usa el propio
 * /browsing_context_suggestions.json de Shopify (IP + idioma del navegador).
 * Reglas (decisión de Guillermo, 2026-10-20; corrección rápida hasta que llegue el banner):
 * - País del visitante SIN mercado (México, Estados Unidos…): no se hace nada; se queda donde está.
 * - País con mercado igual al actual: no se hace nada ni se recarga.
 * - País con mercado distinto del actual: se cambia solo el mercado; el idioma de la página se mantiene siempre
 *   (todos los idiomas están disponibles en todos los mercados).
 * - Solo en la primera visita de cada navegador: si la persona cambia de país o idioma, se respeta para siempre.
 * - Los países con mercado salen de Shopify (window.HmMarkets.countries); no hay países escritos aquí.
 */
(function () {
  'use strict';

  var KEY = 'hm_geo_v1';

  function seen() {
    try {
      return window.localStorage.getItem(KEY) === '1';
    } catch (e) {
      return true; // sin almacenamiento no se puede recordar la elección: mejor no mover a nadie
    }
  }

  function remember() {
    try {
      window.localStorage.setItem(KEY, '1');
    } catch (e) {}
  }

  function returnPath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var path = window.location.pathname;
    if (root !== '/' && path.indexOf(root) === 0) path = '/' + path.slice(root.length);
    return path + window.location.search;
  }

  function apply(target) {
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;
    [
      ['_method', 'PUT'],
      ['form_type', 'localization'],
      ['country_code', target.country],
      ['language_code', target.language],
      ['return_to', returnPath()],
    ].forEach(function (pair) {
      var input = document.createElement('input');
      input.name = pair[0];
      input.value = pair[1];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  function up(v) {
    return String(v || '').toUpperCase();
  }

  // Qué hacer con la respuesta de Shopify: devuelve el país (y el idioma actual) a aplicar, o null si no hay que cambiar nada.
  // markets: lista de códigos de país con mercado (si no se conoce, solo se cambia cuando Shopify sugiere un mercado).
  function decide(current, data, markets) {
    if (!data) return null;
    var country = up(current.country);
    var language = String(current.language || '');
    var parts = data.suggestions && data.suggestions[0] && data.suggestions[0].parts;
    var suggested = parts && parts.country && parts.country.handle ? up(parts.country.handle) : '';
    var detected = data.detected_values && data.detected_values.country && data.detected_values.country.handle;
    var target = suggested || up(detected);
    if (!target || target === country) return null;
    var list = (markets || []).map(up);
    // País sin mercado: ni cambio ni redirección.
    if (list.length ? list.indexOf(target) === -1 : !suggested) return null;
    // El idioma de la página no se toca: todos los idiomas valen en todos los mercados.
    return { country: target, language: language };
  }

  function run() {
    if (seen()) return;
    if (/bot|crawl|spider|lighthouse|headless/i.test(navigator.userAgent) || navigator.webdriver) return;
    var shopify = window.Shopify || {};
    var url =
      ((shopify.routes && shopify.routes.root) || '/') +
      'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true';
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        remember();
        var markets = window.HmMarkets && window.HmMarkets.countries;
        var language = shopify.language || shopify.locale || document.documentElement.lang || '';
        var next = decide({ country: shopify.country, language: language }, data, markets);
        if (next) apply(next);
      })
      .catch(function () {});
  }

  window.HmGeo = { decide: decide };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
